import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgDzenLogo = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 28,
	height: 28,
	viewBox: "0 0 28 28",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("circle", {
		cx: 14,
		cy: 14,
		r: 14,
		fill: "white"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M22 13.8419C22 13.7619 21.935 13.6957 21.855 13.6919C18.9846 13.5832 17.2378 13.2171 16.0156 11.9948C14.791 10.7701 14.4261 9.02178 14.3174 6.14495C14.3149 6.06497 14.2486 6 14.1674 6H13.8325C13.7526 6 13.6863 6.06497 13.6826 6.14495C13.5739 9.02052 13.209 10.7701 11.9844 11.9948C10.761 13.2183 9.01528 13.5832 6.14496 13.6919C6.06497 13.6944 6 13.7607 6 13.8419V14.1768C6 14.2568 6.06497 14.323 6.14496 14.3268C9.01528 14.4355 10.7622 14.8017 11.9844 16.0239C13.2065 17.2461 13.5714 18.9895 13.6813 21.855C13.6838 21.935 13.7501 22 13.8313 22H14.1674C14.2474 22 14.3136 21.935 14.3174 21.855C14.4273 18.9895 14.7922 17.2461 16.0144 16.0239C17.2378 14.8004 18.9834 14.4355 21.8537 14.3268C21.9337 14.3243 21.9988 14.2581 21.9988 14.1768V13.8419H22Z",
		fill: "#4469C6"
	})]
});
export default SvgDzenLogo;
